import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useArchivedDocumentReportsInfiniteQueryKey } from './useArchivedDocumentReportsInfiniteQueryKey'

export const useInvalidateArchivedDocumentReportsInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useArchivedDocumentReportsInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
